module.exports = __webpack_public_path__ + "static/media/street-glide-special-metallic-black.2cc4ab5c.png";